import React, { Component } from "react";
import styles from "./Layouts.local.scss";
import classnames from "classnames";
import { connect } from "react-redux";
import { getUserNameForAvatar } from "Utils";
import { TTP_API_URL } from "Config";
import _ from "i18n";

//  _________________________________
// |                                 |
// |                                 |
// |                                 |
// |                                 |
// |                                 |
// |_________________________________|

class ThankingSlide extends Component {
  renderPresenter = presenter => {
    const {
      id,
      firstName,
      lastName,
      mainEmail,
      mainPhone,
      avatar,
      avatarUrl,
      role
    } = presenter;

    return (
      <div className={styles.presenter_container} key={"presenter" + id}>
        {avatarUrl !== undefined ? (
          <div
            className={styles.avatar}
            style={{ backgroundImage: `url(${avatarUrl})` }}
          />
        ) : avatar ? (
          <div
            className={styles.avatar}
            style={{ backgroundImage: `url(${TTP_API_URL}/${avatar})` }}
          />
        ) : (
          <div className={classnames(styles.avatar, "empty-avatar")}>
            <span>{getUserNameForAvatar(firstName, lastName)}</span>
          </div>
        )}

        <span className={styles.user_name}>{`${firstName} ${lastName}`}</span>
        <span className={styles.user_role}>
          {role && role.id !== undefined ? _(role.type) : "____"}
        </span>
        <span className={styles.user_email}>{mainEmail}</span>
        <span className={styles.user_phone}>
          {mainPhone && mainPhone.length === 12
            ? mainPhone
                .replace(/\D+/g, "")
                .replace(
                  /(\d{2})(\d{3})(\d{2})(\d{2})(\d{2})/,
                  "+$1 (0)$2 $3 $4 $5"
                )
            : mainPhone}
        </span>
      </div>
    );
  };

  render() {
    let { componentsBackground, presenters, currentOrganization } = this.props;

    const customBackground = {
      background: componentsBackground,
      transition: "all 5s ease"
    };

    let logo =
      currentOrganization && currentOrganization.avatarUrl
        ? currentOrganization.avatarUrl
        : null;
    let logoBlock = (
      <span
        className={classnames("boxes__box__logo", styles.deg_logo)}
        style={{ backgroundImage: `url(${logo})` }}
      />
    );

    return (
      <div className={`row ${styles.layout}`}>
        <div
          className={classnames(
            "large-12 medium-12 small-12",
            styles.component_block,
            styles.flex_container,
            styles.align_container
          )}
        >
          <div
            className={classnames(
              styles.component_container,
              styles.container_xl_height,
              styles.Thanking_slide
            )}
            style={customBackground}
          >
            {logoBlock}

            <h2 style={{ marginTop: presenters.length === 0 ? 120 : 40 }}>
              Merci pour votre attention
            </h2>

            {presenters.length > 0 ? <h5>Présentée par</h5> : ""}

            <div
              className={classnames(
                styles.presenters,
                presenters.length > 2 ? styles.minimised_presenters : ""
              )}
            >
              {presenters.map((presenter, i) => {
                return this.renderPresenter(presenter);
              })}
            </div>
            <img
              src={"/img/Logo-Tamtam.png"}
              alt={""}
              className={styles.tamtam_logo}
            />
          </div>
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  presenters: state.presentation.presentationConfig.presenters
});

export default connect(mapStateToProps)(ThankingSlide);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Layouts/ThankingSlide.js